import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {pairwise, startWith} from "rxjs/operators";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-change-order-step-preview',
    templateUrl: './change-order-step-preview.component.html',
    styleUrls: ['./change-order-step-preview.component.scss'],
    standalone: false
})
export class ChangeOrderStepPreviewComponent implements OnInit {
  @Input() step: any;
  @Input() model: any = {};
  @Input() form: any = {};
  @Output() callback = new EventEmitter<any>(true);
  public changeOrder: any = {};
  public drawing: any = {};

  // @ts-ignore
  private changeOderSubscription: Subscription;
  // @ts-ignore
  private drawingSubscription: Subscription;


  constructor() { }

  ngOnInit(): void {
    this.model = this.model?.model;
    this.changeOrder =   this.form.get('step01').get('changeOrder').getRawValue();
    this.drawing =  this.form.get('step02').get('drawingForm').getRawValue();
    this.initSubscriptions();
  }
  initSubscriptions(){
    this.changeOderSubscription = this.form.get('step01').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.changeOrder = next ?.changeOrder;
        // console.log('noteDetail:',this.noteDetail);
      });

    this.drawingSubscription = this.form.get('step02').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.drawing = next ?.drawingForm;
      });
  }
  ngOnDestory(){
    this.changeOderSubscription.unsubscribe();
    this.drawingSubscription.unsubscribe();
  }

}
